import { createSelector } from 'reselect';
import PreconResconConsignmentsDetailsColumns
  from '../../containers/PreconResconConsignmentsDetailsColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PRECON_RESCON_CONSIGNMENTS_DETAILS
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PRECON_RESCON_CONSIGNMENTS_DETAILS.isLoading;

export const getData =
  ReportDefinitions.PRECON_RESCON_CONSIGNMENTS_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PreconResconConsignmentsDetailsColumns);
